import * as React from "react";
import {
  DateField,
  TextField,
  EditButton,
  TextInput,
  SelectInput,
  FunctionField
} from "react-admin";
import { DateRangeInput, NumberRangeInput } from "../../components/input";
import { StatusEnum, PrivacyEnum } from "../../common/enum";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <DateRangeInput source="created_at" label="Created At" />,
  <DateRangeInput source="published_at" label="Published At" />,
  <NumberRangeInput source="id" label="Id" />,
  <SelectInput
    source="status"
    choices={StatusEnum}
  />,
];

export const ArticleList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <FunctionField
        label="Status"
        render={(record) =>
          StatusEnum.find((x) => x.id === record.status)?.name
        }
      />
      <FunctionField
        label="Privacy"
        render={(record) =>
          PrivacyEnum.find((x) => x.id === record.privacy)?.name
        }
      />
      <DateField source="created_at" label="Created At" />
      <DateField source="published_at" label="Published At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
